module.exports = __webpack_public_path__ + "media/images/KVL_Ball-01-cd01c8721fd92ef62cca6d7a6d39e408.svg";